import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, switchMap, take, tap } from 'rxjs/operators';
import { UserClient } from 'src/shared/api';
import { LocalStorageService } from 'src/shared/local-storage.service';
import { AuthService } from '../auth/auth.service';
import * as AppActions from './app.actions';
import { USER_PREFERENCES_KEY } from './local-storage/local-storage-keys';

@Injectable()
export class AppEffects {
	getUserPreferences$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(AppActions.appLaunched),
				tap(() => {
					this.authService
						.isAuthenticated$
						.pipe(
							filter(authenticated => authenticated),
							switchMap(_ => this.userClient.userPreferences()),
							take(1),
							tap((userPrefs) => {
								this.localStorageService.set(
									USER_PREFERENCES_KEY,
									userPrefs
								);
							})
						)
						.subscribe();
				})
			),
		{ dispatch: false }
	);

	constructor(
		private readonly actions$: Actions,
		private readonly userClient: UserClient,
		private readonly localStorageService: LocalStorageService,
		private readonly authService: AuthService
	) { }
}
